<template>
    <!-- <el-col :span="span"> -->
        <el-upload
            class="upload-demo"
            :action="upLoadImg"
            :show-file-list="false"
            :data="UploadData"
            :headers="headers"
            :disabled="disabled"
            :on-success="successUploadForm"
            :on-error="errorUploadForm"
            :before-upload="beforeUploadForm"
            :auto-upload="autoUp"
            :limit="limit"
            :on-exceed="handleExceed"
            :on-remove="romoveUploadForm"
            ref="upload"
            multiple>
            <el-button slot="trigger" type="primary" plain round :size="size" >{{name}}</el-button>
            <!-- <el-button v-if="!autoUp" style="margin-left: 10px;" size="small" type="primary" plain round @click="submitUpload">确认导入</el-button> -->
        </el-upload>
    <!-- </el-col> -->
</template>

<script>
    import { upLoadImg } from '../../../config';
    export default {
        props: {
                /** 上传文件带得参数 */
            UploadData: {
                type: Object,
                default: () => {}
            },
            upLoadImg: {
                type: String,
                default: upLoadImg
            },
            formMaxSize: {
                type: Number,
                default: 50
            },
            span: {
                type: Number,
                default: 1
            },
            limit: {
                type: Number,
                default: 1
            },
            size: {
                type: String,
                default: 'mini'
            },
            /** 是否禁用 */
            disabled: {
                type: Boolean,
                default: false
            },
            autoUp: {
                type: Boolean,
                default: true
            },
            type: {
                type:String,
                default: ''
            },
            name: {
                type: String,
                default: '上传文件'
            }
        },
        data() {
            return {
                headers: {},  //上传Excel的header
                imgs: '',
                one: 1,
                fileList: []
            }
        },
        watch: {
            value: {
                handler: function(val) {
                    if(val){
                        this.imgs = val
                        this.fileList = [{url:val}]
                    }
				},
				immediate: true
            },
        },
        created() {
        },
        methods: {
            /** 上传文件限制 */
            beforeUploadForm(file) {
                // 验证文件大小
                if (file.size / 1024 / 1024 > this.formMaxSize) {
                    this.$message({
                        message: `上传文件大小不能超过${formMaxSize}M!`,
                        type: 'warning',
                        customClass: 'adminMsg'
                    });
                    return false
                }
                // 中文乱码处理
                if (file.raw) {
                    let reader = new FileReader() // 读取文件内容
                    reader.readAsText(file.raw, 'gb2312') // 防止中文乱码问题，不加reader.onload方法都不会触发
                    reader.onload = function (e) {
                        this.contentHtml = e.target.result // txt文本内容，接下来就可以对其进行校验处理了
                    }
                }
                // 验证文件类型
                var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                if(this.type==='video'){
                    const extension = testmsg === 'mp4'
                    if (!extension) {
                        this.$message({
                            message: '上传文件只能是mp4格式!',
                            type: 'warning',
                            customClass: 'adminMsg'
                        });
                    }
                    return extension
                }else if(this.type==='pdf'){
                    const extension = testmsg === 'pdf'
                    if (!extension) {
                        this.$message({
                            message: '上传文件只能是pdf格式!',
                            type: 'warning',
                            customClass: 'adminMsg'
                        });
                    }
                    return extension
                }
            },
            /** 图片上传成功之后 */
            successUploadForm(res) {
                if(res.code === 200){
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        customClass: 'adminMsg'
                    });
                    this.imgs = res.data.fileUrl
                    this.$emit('input', this.imgs)
                    this.$emit('success', this.imgs)
                }
            },
            handleExceed(files, fileList) {
                this.$message({
                    message: `当前限制选择 ${this.limit} 个文件，请先删除后再上传`,
                    type: 'warning',
                    customClass: 'adminMsg'
                });
                // this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            /** 删除图片之前 */
            romoveUploadForm(file) {
                console.log(file)
                if (file.status === 'success') {
                    this.imgs = ''
                    this.fileList = []
                    this.$emit('input', this.imgs)
                }
            },
            /** 文件上传失败 */
            errorUploadForm() {
                this.$message({
                    message: '上传失败',
                    type: 'error',
                    customClass: 'adminMsg'
                });
            },
            upload(){
                this.$refs.upload.$children[0].$refs.input.click();
            }
        },
    }
</script>

<style lang='less' scoped>
    .el-col-1 {
        width: 100px;
    }
</style>